import React, { Children, cloneElement, isValidElement } from 'react'
import clsx from 'clsx'
import { AccordionIndexType, useAccordion } from './accordion-context'

import * as styles from './accordion.module.scss'

type Props = React.ComponentProps<'div'> & {
  index: AccordionIndexType
}

export const AccordionItem = ({
  className,
  children,
  index,
  ...props
}: Props) => {
  const [isOpen] = useAccordion()
  const active = index === isOpen

  return (
    <div
      className={clsx(styles.item, className, active && styles.open)}
      {...props}
    >
      {Children.map(children, (child) =>
        isValidElement(child) ? cloneElement<any>(child, { index }) : child
      )}
    </div>
  )
}
